<template>
  <v-container class="scrollable-div">
    <h5 class="text-h6 text-typo font-weight-bold mb-2">All Locations</h5>
    <div>
      <v-row v-for="item in items" :key="item.key">
        <v-col>
          <v-btn text :to="'/location/' + item.key">
            <h5>{{ item.name }}</h5>
          </v-btn>
        </v-col>
        <!-- <v-col v-if="item.key === location.key">
          <v-btn text :to="'/location/' + location.key">
            <h5>{{ location.name }}</h5>
          </v-btn>
        </v-col> -->
      </v-row>
    </div>
  </v-container>
</template>
<script>
import { fetchObjects } from "../../services/firebase-helpers";

export default {
  name: "LocationList",
  props: {
    items: Array,
  },
  data: () => ({
    list: null,
  }),
  computed: {
    location() {
      return this.$store.state.location;
    },
    locations() {
      return this.$store.state.locations;
    },
  },
  methods: {
    getData() {
      fetchObjects("locations").then((data) => {
        this.list = data
      });
    },
  },
  async mounted() {
    await this.$store.dispatch(
      "handleUserLocations",
      this.$store.state.auth.uid
    );
  },
};
</script>
<style scoped>
.scrollable-div {
  height: 375px; /* Set the height you need */
  overflow-y: auto; /* Enable vertical scrolling */
  overflow-x: hidden; /* Disable horizontal scrolling */
  font-weight: 10px !important;
}
</style>
